var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveWithTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 25C49 38.2548 38.2548 49 25 49C11.7452 49 1 38.2548 1 25C1 11.7452 11.7452 1 25 1C38.2548 1 49 11.7452 49 25Z",
    stroke: "#3B968B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 25C40 33.2843 33.2843 40 25 40C16.7157 40 10 33.2843 10 25C10 16.7157 16.7157 10 25 10C33.2843 10 40 16.7157 40 25Z",
    fill: "#3B968B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7117 22.7895C31.0961 22.3801 31.0961 21.7164 30.7117 21.307C30.3273 20.8977 29.7041 20.8977 29.3197 21.307L23.5315 27.4715L21.6803 25.5C21.2959 25.0906 20.6727 25.0906 20.2883 25.5C19.9039 25.9094 19.9039 26.5731 20.2883 26.9824L22.8334 29.693C23.0261 29.8982 23.2788 30.0005 23.5314 30C23.784 30.0006 24.0368 29.8982 24.2295 29.693L30.7117 22.7895Z",
    fill: "#FFF6EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveWithTick);
export default __webpack_public_path__ + "static/media/activeWithTick.c759462180c7993f73bb6557fa752059.svg";
export { ForwardRef as ReactComponent };